export const NavalConstants = {
    GRADOS: [
        "MARINERO", "CABO", "TERCER_MAESTRE", "SEGUNDO_MAESTRE", "PRIMER_MAESTRE",
        "TENIENTE_CORBETA", "TENIENTE_FRAGATA", "TENIENTE_NAVIO", "CAPITAN_CORBETA"
    ],

    CUERPOS_Y_SERVICIOS: [
        "Cuerpo General (CG)",
        "Infantería de Marina (IM)",
        "Aeronáutica Naval (AN)",
        "Mecánicos Navales",
        "Administración e Intendencia Naval",
        "Sanidad Naval",
        "Ingenieros de la Armada",
        "Justicia Naval"
    ],

    ESPECIALIDADES: {
        "Cuerpo General (CG)": [
            "Cubierta",
            "Máquinas",
            "Armamento",
            "Telecomunicaciones",
            "Electrónica",
            "Electricidad"
        ],
        "Infantería de Marina (IM)": [
            "Fusileros",
            "Comandos",
            "Anfibios",
            "Blindados"
        ],
        "Administración e Intendencia Naval": [
            "Oficinistas",
            "Contabilidad",
            "Almacenes"
        ],
        "Mecánicos Navales": [
            "Combustión Interna",
            "Electricidad Naval",
            "Refrigeración"
        ]
    }
};
